/**
 * Serialise a value to JSON safe to inline into a `<script>` via `dangerouslySetInnerHTML` (React)
 * or `set:html` (Astro) — both output their content RAW/unescaped, so a `<` inside a JSON string
 * value (e.g. a `</script>` in a translation, a dehydrated query value, or a JSON-LD field derived
 * from a request path) would close the surrounding `</script>` early (premature-close / XSS or, at
 * minimum, document corruption). `<` is escaped to its JSON unicode escape, which `JSON.parse` (and
 * crawlers) restore to `<`, so the parsed value is unchanged.
 *
 * Single source of truth for every inline `<script>` payload built from request/CMS-influenced data
 * across both apps (atlas-astro's i18n catalog, per-page data-island store and JSON-LD; the shared
 * `Breadcrumbs` component's JSON-LD).
 */
export function escapeJsonForInlineScript(value: unknown): string {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}
